





























































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { Snack, SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import { editSelfPassword } from '@/modules/User/gql/user.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppDialog
  }
})
export default class ChangePassword extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Setting'
    },
    {
      text: 'Password'
    }
  ]

  valid = true
  showOldPWD = false
  showNewPWD = false
  showConfirmPWD = false

  oldPassword = ''
  newPassword = ''
  confirmPassword = ''

  confirmDialog = false
  disableConfirm = false

  rules = {
    required: (value:string) => !!value || 'Required.',
    min: (value: string) => value.length >= 6 || 'Min 6 characters'
  }

  get form (): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  validate (event: Event) {
    if (this.form.validate()) {
      this.save()
    }
  }

  get passwordConfirmationRule () {
    return () => (this.newPassword === this.confirmPassword) || 'Passwords entered twice are inconsistent'
  }

  save () {
    this.confirmDialog = true
  }

  async confirm () {
    this.disableConfirm = true
    try {
      const result = await this.$apollo.mutate({
        mutation: editSelfPassword,
        variables: {
          newPassword: this.newPassword,
          oldPassword: this.oldPassword
        }
      })
      showNotification({
        msg: 'Edit password successfully',
        type: SnackType.Success
      })
      setTimeout(() => {
        localStorage.removeItem(process.env.VUE_APP_JWT_NAME || 'VERGE_JWT_TOKEN')
        this.$router.replace({ name: 'SignIn' })
      }, 1000)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
    this.confirmDialog = false
    this.disableConfirm = false
  }
}
